import { useCallback, useEffect, useRef, useState } from "react";
import HomeHero from "./home-hero";
import HomeAbout from "./home-about";

import ProjectSection from "./home-works";
import RecentPosts from "./components/recent-post";
import HomeContact from "./home-contact";
import MainGrid from "./components/main-grid";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "swiper/css";
import "swiper/css/navigation";

const Home = () => {
  const mainRef = useRef<HTMLDivElement>(null);
  const [readyCount, setReadyCount] = useState(0);

  // 비동기 완료 후 ScrollTrigger 리프래시
  useEffect(() => {
    if (readyCount === 2) {
      ScrollTrigger.refresh();
    }
  }, [readyCount]);

  // Resize ScrollTrigger 리프래시
  useEffect(() => {
    let timeoutId: number | null = null;

    const handleResize = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        ScrollTrigger.refresh();
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  const onReady = useCallback(() => setReadyCount((prev) => prev + 1), []);

  return (
    <>
      <div
        className="relative flex flex-col gap-10 overflow-hidden lg:overflow-visible   bg-[#171717] "
        ref={mainRef}
      >
        {/* Hero Section */}
        <HomeHero />
        <div className="grid-layout">
          {/* About */}
          <MainGrid>
            <HomeAbout />
          </MainGrid>
          {/* <MainGrid>
            <HomeStack />
          </MainGrid> */}
          {/* Project */}
          <MainGrid>
            <ProjectSection onReady={onReady} />
          </MainGrid>

          <MainGrid>
            <RecentPosts page={4} onReady={onReady} />
          </MainGrid>
        </div>
        {/* Contact */}

        <HomeContact />
      </div>
    </>
  );
};

export default Home;
